import type { FaireProductEntity } from "../../entity_types/product";

export const p_4te66x7yz8: FaireProductEntity = {
  token: "p_4te66x7yz8",
  type: "product",
  name: "Baby Organic Knotted Gown + Top Knot Hat | Sugar White",
  brandToken: "b_a1kpo4g3o4",
  brandName: "Fawn & Foster",
  imageUrl:
    "https://cdn.faire.com/fastly/8b3323e03d28a661a3175b6f61c3263cda1f8ec73640c497f3cef72bedc31c3a.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/e9640ea75d2fb8e91a40340fd74a3f5dbee6c81bd46c619413abd62f6446d5e6.png",
    "https://cdn.faire.com/fastly/362e171e0344bd99d2b26fe7c1be4a9c49213c065862a8a249cebc5c937d3ec8.jpeg",
    "https://cdn.faire.com/fastly/3e27b33bb8d8f0c36e3555d636996cf03bf190b437ae106d2ef8fd08b52f3231.jpeg",
    "https://cdn.faire.com/fastly/bbd5a813ed143276f3f4a317edc824cf67ccccc8ba2e5bbf54e7a9e199eead89.webp",
    "https://cdn.faire.com/fastly/4a20346e467df186a41e325b05ca3d25915d5560e721f50d360886b26597b061.jpeg",
    "https://cdn.faire.com/fastly/b2cb646f99d3e7fba59c4de97b4ea9586e9c18a7b94ba347c0287227c18c3dd9.webp",
    "https://cdn.faire.com/fastly/66dd957e7338ae431eb8a6ac696eafecb0a1f762cd4c549acc6c6967f2ca644a.jpeg",
    "https://cdn.faire.com/fastly/75047477104e132af7e40dd9cb802e11b3552e3c06baf2b3c1bdcab015ce256a.jpeg",
  ],
  priceDollars: 7.5,
  description:
    "SUPER SOFT:  Certified organic cotton with 5% spandex for the perfect fit + stretch🌿\n\nEASY TO USE:  Simply open buttons at neckline and slide gown from baby’s feet up to shoulders, then insert baby’s arms.  Sleepwear, meant to fit snug. Features fold over sleeves to tuck in baby's hands.\n\nPERFECT ANNOUNCEMENT + COMING HOME OUTFIT❤\n\nCONTENTS:  One knotted gown + top knot hat.\n\nVERSATILE:  Endless mixing and matching with our organic swaddles + headbands!\n\nSIZE:  Newborn - 3 months.  Fits 0-15 lbs. approximately.\n\nBEAUTIFUL GIFT:  All Fawn & Foster products arrive in gorgeous, minimal packaging. Our mission of donating a portion of proceeds to helping foster children & other children in-need is stated on every package, so you feel confident in your purchase whether for yourself or as a gift. Thank you for your love and support of our mission to help these sweet children 🎁",
  tags: [],
  msrpDollars: 34.99,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-25T20:49:13.205Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
